import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  const { lang = "en" } = useParams<{ lang?: string }>();

  const getPath = (page: string) => `/${lang}/${page}`;

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      {/* Disclaimer Banner */}
      <div className="bg-secondary-50 border-b border-secondary-200/50">
        <div className="container-limit mx-auto px-4 md:px-6 lg:px-8 py-3">
          <p className="text-xs md:text-sm text-center text-secondary-700">
            {t("footer.disclaimer")}
          </p>
        </div>
      </div>

      <div className="container-limit mx-auto px-4 md:px-6 lg:px-8 py-10 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-1">
            <Link to={`/${lang}/`} className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-foreground-950">
                AllChinaBuy
              </span>
              <span className="block text-xs font-label font-medium mt-0.5 text-foreground-500">
                Spreadsheet Hub
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              {t("meta.description")}
            </p>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.resources")}</h4>
            <ul className="space-y-2">
              <li><Link to={getPath("allchinabuy-spreadsheet")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("resources.spreadsheet")}</Link></li>
              <li><Link to={getPath("allchinabuy-finds")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("resources.finds")}</Link></li>
              <li><Link to={getPath("allchinabuy-products")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("resources.products")}</Link></li>
              <li><Link to={getPath("allchinabuy-coupon")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("resources.coupon")}</Link></li>
            </ul>
          </div>

          {/* Guides */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.guides")}</h4>
            <ul className="space-y-2">
              <li><Link to={getPath("allchinabuy-review")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("guides.reviewGuide")}</Link></li>
              <li><Link to={getPath("allchinabuy-shipping")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("guides.shippingCost")}</Link></li>
              <li><Link to={getPath("allchinabuy-warehouse")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("guides.warehouseGuide")}</Link></li>
              <li><Link to={getPath("allchinabuy-qc")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("guides.qcGuide")}</Link></li>
              <li><Link to={getPath("allchinabuy-safety")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("guides.safetyGuide")}</Link></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.about")}</h4>
            <ul className="space-y-2">
              <li><Link to={getPath("about")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer.about")}</Link></li>
              <li><Link to={getPath("contact")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer.contact")}</Link></li>
              <li><Link to={getPath("privacy")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer.privacy")}</Link></li>
              <li><Link to={getPath("terms")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer.terms")}</Link></li>
              <li><Link to={getPath("faq")} className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors">{t("footer.editorial")}</Link></li>
            </ul>
          </div>

          {/* Language */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">{t("footer.language")}</h4>
            <ul className="space-y-2">
              <li><Link to="/en/" className={`text-sm transition-colors ${lang === "en" ? "text-primary-600 font-medium" : "text-foreground-600 hover:text-foreground-950"}`}>English</Link></li>
              <li><Link to="/fr/" className={`text-sm transition-colors ${lang === "fr" ? "text-primary-600 font-medium" : "text-foreground-600 hover:text-foreground-950"}`}>Français</Link></li>
              <li><Link to="/da/" className={`text-sm transition-colors ${lang === "da" ? "text-primary-600 font-medium" : "text-foreground-600 hover:text-foreground-950"}`}>Dansk</Link></li>
              <li><Link to="/de/" className={`text-sm transition-colors ${lang === "de" ? "text-primary-600 font-medium" : "text-foreground-600 hover:text-foreground-950"}`}>Deutsch</Link></li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-background-200/70">
        <div className="container-limit mx-auto px-4 md:px-6 lg:px-8 py-4">
          <p className="text-xs text-center text-foreground-500">
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
}